module.exports = __webpack_public_path__ + "img/rubyonrailslogo.a788e3aa.png";